export default "__VITE_ASSET__BxF8955g__"